"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RowCell = _interopRequireDefault(require("./RowCell"));

var _utils = require("../../../utils");

var _PropTypes$shape2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Row = function Row(_ref) {
  var data = _ref.data,
      index = _ref.index,
      hidden = _ref.hidden,
      columns = _ref.columns,
      level = _ref.level,
      scrollable = _ref.scrollable,
      expandedRows = _ref.expandedRows,
      onRow = _ref.onRow,
      expandOnClick = _ref.expandOnClick;

  var _useState = (0, _react.useState)(expandedRows.includes(data.key)),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var rowProps = onRow(data, index) || {
    className: ''
  };
  var className = (0, _utils.getClassNames)(rowProps.className, "row-level-".concat(level));
  (0, _react.useEffect)(function () {
    setExpanded(expandedRows.includes(data.key));
  }, [expandedRows, data.key]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", _extends({
    role: "row",
    hidden: hidden
  }, rowProps, {
    className: className
  }), columns.map(function (column, index) {
    return /*#__PURE__*/_react.default.createElement(_RowCell.default, {
      row: data,
      data: data[column.key],
      index: index,
      level: level,
      column: column,
      expanded: expanded,
      scrollable: scrollable,
      onExpand: function onExpand() {
        return expandOnClick(data.key);
      }
    });
  })), data.children && data.children.map(function (item, ind) {
    return /*#__PURE__*/_react.default.createElement(Row, {
      data: item,
      index: ind,
      level: level + 1,
      hidden: !expanded,
      columns: columns,
      scrollable: scrollable
    });
  }));
};

Row.propTypes = {
  data: _propTypes.default.shape((_PropTypes$shape2 = {
    key: _propTypes.default.string
  }, _defineProperty(_PropTypes$shape2, _propTypes.default.string, _propTypes.default.any), _defineProperty(_PropTypes$shape2, "children", _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.any)))), _PropTypes$shape2)),
  index: _propTypes.default.number,
  level: _propTypes.default.number,
  hidden: _propTypes.default.bool,
  scrollable: _propTypes.default.bool,
  expandedRows: _propTypes.default.arrayOf(_propTypes.default.string),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.any))),
  onRow: _propTypes.default.func,
  expandOnClick: _propTypes.default.func
};
Row.defaultProps = {
  data: {
    children: undefined
  },
  index: 0,
  level: 0,
  hidden: false,
  scrollable: false,
  expandedRows: [],
  columns: [],
  onRow: function onRow() {
    return {};
  },
  expandOnClick: function expandOnClick() {}
};
var _default = Row;
exports.default = _default;